import '.cp{max-width:480px;}.ssr-plugin'
import '.a{width:100%;}.ssr-plugin'
import '.cq{border-radius:24px;}.ssr-plugin'
import '.ap{position:relative;}.ssr-plugin'
import '.c0{padding:48px;}.ssr-plugin'
import '.p{flex-direction:column;}.ssr-plugin'
import '.o{display:flex;}.ssr-plugin'
import '.v{align-items:center;}.ssr-plugin'
import '.bb{justify-content:center;}.ssr-plugin'
import '.aw{text-align:center;}.ssr-plugin'
import '.ay{overflow:hidden;}.ssr-plugin'
import '.b3{margin-bottom:16px;}.ssr-plugin'
import '.cr{margin-bottom:24px;}.ssr-plugin'
import { styled } from 'inlines'
import { colors } from '../utils/colors.js'
import { Button } from './Button.js'
import { ModalWrapper, MODAL_PANEL_ANIMATION } from './ModalWrapper.js'
import { transparentColor } from '../utils/transparentcolor.js'
import { useDictionary } from '../hooks/useDictionary.js'

export const AnnouncementModal = ({ setModal, announcement }) => {
  const dictionary = useDictionary()
  return (
    <ModalWrapper onDismiss={() => {}}>
      <div className="cp a cq ap c0 p o v bb aw ay"
        style={{
          border: `1px solid ${colors.border}`,
          backgroundColor: `${transparentColor(colors.secondary, 0.9)}`,
          animation: MODAL_PANEL_ANIMATION,
        }}
      >
        <div className="ap">
          <h3 className="b3">Announcement</h3>
          <p className="cr">{announcement}</p>
          <Button
            onClick={() => {
              setModal(false)
            }}
            style={{ margin: '0 auto' }}
          >
            {dictionary.closeButton}
          </Button>
        </div>
      </div>
    </ModalWrapper>
  )
}
